var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlide2BgShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 742,
    height: 702,
    viewBox: "0 0 742 702",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M182.188 504.069C146.111 380.766 254.65 340.821 306.812 328.77C420.473 302.533 463.748 208.216 408.055 158.597C347.338 104.498 256.074 205.127 233.539 173.804C188.128 110.675 297.107 98.4582 308.952 65.1653C320.797 31.9043 278.78 0 278.78 0H0C0 0 167.796 25.1494 184.221 58.6123C200.682 92.0752 163.687 123.675 198.17 167.049C245.38 226.444 339.393 156.833 374.553 187.377C423.934 230.277 385.618 307.623 306.571 325.749C246.769 339.46 106.194 385.65 87.9663 491.476C62.1722 641.353 189.683 682.112 295.134 663.243C365.559 650.651 451.595 584.979 451.595 584.979C451.595 584.979 227.595 659.308 182.185 504.069H182.188Z",
    fill: "url(#paint0_linear_7761_84890)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M507.937 543.882C420.813 539.164 368.173 604.666 368.173 604.666V604.669L385.041 627.849C385.041 627.849 458.077 574.801 564.239 605.721C641.876 628.338 695.885 663.368 742 701.206V680.483C726.704 665.966 714.059 652.329 703.351 640.783C696.758 633.672 690.899 627.354 685.608 622.111C643.828 580.742 595.092 548.565 507.937 543.882Z",
    fill: "url(#paint1_linear_7761_84890)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7761_84890",
    x1: 349.754,
    y1: 692.288,
    x2: 349.754,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.510032,
    stopColor: "#3962AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3962AB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7761_84890",
    x1: 368.776,
    y1: 720.171,
    x2: 742,
    y2: 720.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507113,
    stopColor: "#3962AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3962AB",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide2BgShape);
export default __webpack_public_path__ + "static/media/slide_2_bg_shape.7d6c2562961f7c8c91b7eaab1e8b6b9d.svg";
export { ForwardRef as ReactComponent };